import React from "react";
import { Provider } from "react-redux";
import ClientProfileModule from "./clientProfileModule";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import reducer from "./redux/clientProfileReducer";
import saga from "./redux/clientProfileSaga";

const ClientProfilePage = ({ notifications }) => {
  return (
    <ErrorBoundary moduleName="clientProfileModule">
      <Provider store={createReduxStore(reducer, "clientProfileModule", saga)}>
        <ClientProfileModule {...notifications} />
      </Provider>
    </ErrorBoundary>
  );
};

export default ClientProfilePage;
